/* Svensk katalog for locale-settings-integrations-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'set.integr.wooImported': '{orders} försäljnings- och returhändelser importerade',
  'set.integr.wooLastSync': 'Senast synkroniserat {date}',
  'set.integr.wooDisconnectTitle': 'Koppla från WooCommerce',
  'set.integr.wooDisconnectHelp': 'Plumme slutar hämta nya ordrar och returer. Redan importerade händelser och bokförda dagsavslut behålls med verifieringskedja.',
  'set.integr.wooDisconnectedToast': 'WooCommerce är frånkopplat.',
  'set.integr.wooDisconnectError': 'Det gick inte att koppla från WooCommerce.',
  'set.integr.wooUnavailable': 'WooCommerce-integrationen är inte tillgänglig i den här versionen.',
});
